import React from 'react';

import { Group, Text } from '@mantine/core';
import { IconUser, IconUsersGroup } from '@tabler/icons-react';
import type { WorkoutList } from 'types';
import { assignedToLabel } from 'utils/workout.helpers';

interface AssignedToCellProps {
  workout: Pick<WorkoutList, 'kiloClassType' | 'athlete'>;
}

/** The Assigned To column in every workout table: a class and an athlete read differently at a glance. */
const AssignedToCell = ({ workout }: AssignedToCellProps): JSX.Element => {
  const label = assignedToLabel(workout);
  if (!label) return <Text>-</Text>;

  const isClass = Boolean(workout.kiloClassType);
  const Icon = isClass ? IconUsersGroup : IconUser;

  return (
    <Group spacing={6} noWrap data-cy={isClass ? 'assignedToClass' : 'assignedToAthlete'}>
      <Icon size={14} stroke={1.75} aria-label={isClass ? 'Class' : 'Athlete'} />
      <Text>{label}</Text>
    </Group>
  );
};

export default AssignedToCell;
